module.exports = __webpack_public_path__ + "static/media/kindergarten.87c8c937.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/features/kindergarten.svg
// module id = 1532
// module chunks = 0